import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import { BaseUrl } from '../helper/BaseUrl';
import { useLocation } from 'react-router-dom';
import FaqContext from '../contexts/FaqContext';

export default function GlobalFaq({ initialData }) {
  const [activeKey, setActiveKey] = useState("0");
  const contextFaq = useContext(FaqContext);
  const [data, setData] = useState(initialData || contextFaq);
  const location = useLocation();

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchFaq = async () => {
      try {
        const normalizedPath =
          location.pathname !== '/' && location.pathname.endsWith('/')
            ? location.pathname.slice(0, -1)
            : location.pathname;
        const pageUrl = new URL(normalizedPath, window.location.origin).href;

        const response = await fetch(`${BaseUrl}/api/faq-by-url`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ url: pageUrl }),
          signal: controller.signal,
        });

        const result = await response.json();

        if (!response.ok || result.error) {
          throw new Error(result.message || "Unable to fetch FAQ data.");
        }

        setData(result.faq || {});
        setActiveKey("0");
      } catch (error) {
        if (error.name !== "AbortError") {
          setData(null);
          console.error("FAQ fetch error:", error.message);
        }
      }
    };

    fetchFaq();

    return () => controller.abort();
  }, [location.pathname]);

  return (
    <>
      {Object.keys(data? data : {}).length > 0 && (
        <div className="global-faq-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h4 className="heading center-heading">Frequently Asked Questions</h4>

                <Accordion activeKey={activeKey} className="globalfaq">
                  {data?.faqs?.map((faqs, index) => {
                    const key = index.toString();
                    return (
                      <Card key={faqs?._id || index} className={`accordion-items ${activeKey === key ? "active" : ""}`}>
                        <Card.Header>
                          <Accordion.Item eventKey={key}>
                            <Accordion.Header as="span" onClick={() => handleToggle(key)}>
                              <label>{faqs?.question}</label>
                              <span>{activeKey === `${index}` ? "−" : "+"}</span>
                            </Accordion.Header>

                            <Accordion.Body>
                              <p>{faqs?.answer}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Card.Header>
                      </Card>
                    );
                  })}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
